import Vue from 'vue'
import VueRouter from 'vue-router'
import DashboardIndex from '../views/dashboard/DashboardIndex'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    component: () => import('../layouts/main-layout.vue'),
    children: [
      {
        path: '/',
        name: 'Dashboard',
        component: DashboardIndex
      },
      {
        path: '/orders',
        name: 'Orders',
        component: () => import('../views/orders/OrdersIndex')
      },
      {
        path: '/profile',
        name: 'Profile',
        component: () => import('../views/profile/Profile')
      }
    ]
  },
  {
    path: '',
    component: () => import('../layouts/full-page.vue'),
    children: [
      {
        path: '/login',
        name: 'Login',
        component: () => import('../views/auth/Login')
      },
      {
        path: '/sign-up',
        name: 'SignUp',
        component: () => import('../views/auth/SignUp')
      }
    ]
  },
  {
    path: '*',
    component: () => import('../views/Error-404')
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return {
      x: 0,
      y: 0
    }
  },

  routes
})

router.afterEach(() => {
  // Remove initial loading
  // TODO Check if options&menu is true before executing
  store.dispatch('rwd/toggleOptions', false)
  // store.dispatch('rwd/toggleMenu', false)
  //
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

// router.beforeEach((to, from, next) => {
//   const auth = false
//   if (!auth) next('/login')
//   else next()
//
//
// })

// router.beforeEach((to, from, next) => {
//   const auth = true
//   const au = true
//   if (!auth || !au) {
//     next({ name: 'Login' })
//   } else {
//     next()
//   }
// })

export default router
